import gracePhoto from "../assets/grace.jpg";
import ecan from "../assets/ecan.jpg";
function Works() {
  return (
    <section id="works" className="py-24 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-20">
          <h2 className="text-6xl md:text-7xl font-black mb-6">Recent Works</h2>
          <p className="text-xl text-gray-600">
            Projects making real difference
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Card 1 */}
          <div
            className={
              "group relative overflow-hidden rounded-3xl shadow-xl bg-white " +
              "transition-transform duration-500 ease-in-out " +
              "hover:scale-105 hover:shadow-2xl hover:z-20 " +
              "hover:ring-4 hover:ring-green-400/30 "
            }
            style={{ animationDelay: `0ms` }}
          >
            {/* Card Background */}
            <div className="absolute inset-0 bg-gradient-to-br from-yellow-400 via-orange-400 to-pink-500 opacity-0 group-hover:opacity-30 transition-opacity duration-500"></div>

            {/* Image/Icon Section */}
            <div className="h-80 bg-gradient-to-br from-yellow-400 via-orange-400 to-pink-500 flex flex-col items-center justify-center text-9xl relative overflow-hidden">
              {/* Overlay for better face visibility */}
              <img
                src={ecan}
                alt="ECAN Vice President"
                className="absolute inset-0 w-full h-full object-cover z-0"
              />
              <div className="absolute inset-0 bg-black/40 z-10"></div>
              {/* Centered face/profile image */}
              <img
                src={ecan}
                alt="ECAN Vice President Face"
                className="relative z-20 w-28 h-28 object-cover rounded-full border-4 border-white mx-auto my-auto"
                style={{
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  position: "absolute",
                }}
              />
            </div>

            {/* Content Section */}
            <div className="relative z-10 p-8 bg-white space-y-4">
              <h3 className="text-2xl font-black text-gray-900 flex items-center gap-2">
                President, ECAN
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Elected as the President of the Educational Consultancy
                Association of Nepal (ECAN), leading initiatives for systemic
                change and unity in the education consultancy sector.
              </p>
            </div>
          </div>

          {/* Card 2 */}
          <div
            className={
              "group relative overflow-hidden rounded-3xl shadow-xl bg-white " +
              "transition-transform duration-500 ease-in-out " +
              "hover:scale-105 hover:shadow-2xl hover:z-20 " +
              "hover:ring-4 hover:ring-green-400/30 "
            }
            style={{ animationDelay: `100ms` }}
          >
            {/* Card Background */}
            <div className="absolute inset-0 bg-gradient-to-br from-green-400 via-emerald-400 to-cyan-400 opacity-0 group-hover:opacity-30 transition-opacity duration-500"></div>

            {/* Image/Icon Section */}
            <div className="h-80 bg-gradient-to-br from-green-400 via-emerald-400 to-cyan-400 flex flex-col items-center justify-center text-9xl relative overflow-hidden">
              {/* Overlay for better face visibility */}
              <img
                src={gracePhoto}
                alt="Grace International"
                className="absolute inset-0 w-full h-full object-cover z-0"
              />
              <div className="absolute inset-0 bg-black/40 z-10"></div>
              {/* Centered face/profile image */}
              <img
                src={gracePhoto}
                alt="Grace International Face"
                className="relative z-20 w-28 h-28 object-cover rounded-full border-4 border-white mx-auto my-auto"
                style={{
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  position: "absolute",
                }}
              />
            </div>

            {/* Content Section */}
            <div className="relative z-10 p-8 bg-white space-y-4">
              <h3 className="text-2xl font-black text-gray-900 flex items-center gap-2">
                Director, Grace International Consultancy
              </h3>
              <p className="text-gray-700 leading-relaxed">
                As Director, I have expanded Grace International to new heights,
                mentoring students and building a trusted brand in global
                education.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Works;
